module.exports = {"project":{"name":"表单设计器"},"headNav":[{"name":"首页","path":"/index"},{"name":"体验","path":"/start"},{"name":"文档","path":"/component"}],"leftNav":[{"name":"开发指南","path":"/component/guide"},{"name":"更新日志","path":"/component/log"},{"name":"首屏组件","path":"/component/riceIndex"},{"name":"表单动态渲染","path":"/component/ricePreviewBridge"},{"name":"表单预览","path":"/component/ricePreviewForm"},{"name":"渲染预览","path":"/component/ricePreviewRender"},{"name":"测试页面","path":"/component/test"}]}


//////////////////
// WEBPACK FOOTER
// ./examples/json/web.config.json
// module id = fMcT
// module chunks = 13